import { render, staticRenderFns } from "./CreateMerchantStep1.vue?vue&type=template&id=8bd12444&"
import script from "./CreateMerchantStep1.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports